/**
 * @file new-request.tsx
 * @deprecated Copied to app/modules/procurement/pages/vendors_management/kyc-verification/new-request.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/vendors_management/kyc-verification/new-request
 * @description Page component for managing new request KYC verification in the vendors management section.
 *   Displays a list of new request KYC verification with pagination, search functionality, and CRUD operations.
 *   Allows users to view the details of new request KYC verification with warehouse context integration.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import {MouseEvent, useState} from "react";
import {Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import Loader from "../../../../../Global/loader";
import Pagination from "../../../../../Global/pagination";
import Method from "../../../../../utils/methods";
import {setKey} from "../../../../../Global/history";
import {listKycVerification} from "../../../../../utils/storeString";
import {AllSeller, KycVerifications, View} from "../../../../../utils/constants";
import {useAuth} from "../../../auth";
import PermissionModal from "../../../../modals/permission";
const NewRequest = (props: any) => {
    const {currentUser} = useAuth();
    const [showPermissionModal, setShowPermissionModal] = useState(false);
    const navigate = useNavigate();
    const [sortClass, setSortClass] = useState({
        sellerName: 1,
        businessName: 1,
        joinedOn: 1,
    });
    const changeSortClass = (event: MouseEvent<HTMLTableCellElement>) => {
        let currentValue = (event.target as HTMLTableCellElement).abbr;
        let sort = sortClass;
        sort = {
            ...sort,
            [currentValue]: sort[currentValue as keyof typeof sort] === 1 ? -1 : 1,
        };
        setSortClass(sort);
    };
    const handleSellerProfile = (id: string) => {
        let currentScrollY = window.scrollY;
        setKey(listKycVerification.scrollPosition, currentScrollY);
        setKey(listKycVerification.search, props.search, false);
        navigate("/UProcure/vendors/vendor-profile", {
            state: {id: id, moduleName: KycVerifications},
        });
    };
    return (
        <>
            {showPermissionModal && (
                <PermissionModal
                    show={showPermissionModal}
                    onHide={() => setShowPermissionModal(false)}
                    moduleName={"seller"}
                />
            )}
            {props.fetchLoader || !props.sellerData ? (
                <>
                    <div className="d-flex justify-content-center">
                        <Loader loading={true} />
                    </div>
                </>
            ) : (
                <>
                    {props.sellerData.length ? (
                        <>
                            <div className="table-responsive mt-2">
                                <table className="table table-row-bordered align-middle gy-6 gs-7">
                                    <thead>
                                        <tr className="fw-bold fs-16 text-black">
                                            <th
                                                // className={
                                                //   sortClass.sellerName === 1
                                                //     ? 'min-w-275px table-sort-asc'
                                                //     : 'min-w-275px table-sort-desc'
                                                // }
                                                className="min-w-275px"
                                                abbr="sellerName"
                                                // onClick={(e) => {
                                                //   changeSortClass(e)
                                                // }}
                                            >
                                                Seller name
                                            </th>
                                            <th
                                                abbr="businessName"
                                                // className={
                                                //   sortClass.businessName === 1
                                                //     ? 'min-w-275px table-sort-asc'
                                                //     : 'min-w-275px table-sort-desc'
                                                // }
                                                // onClick={(e) => {
                                                //   changeSortClass(e)
                                                // }}
                                                className="min-w-275px"
                                            >
                                                Business name
                                            </th>
                                            <th
                                                abbr="joinedOn"
                                                // className={
                                                //   sortClass.joinedOn === 1
                                                //     ? 'min-w-175px table-sort-asc'
                                                //     : 'min-w-175px table-sort-desc'
                                                // }
                                                // onClick={(e) => {
                                                //   changeSortClass(e)
                                                // }}
                                                className="min-w-175px"
                                            >
                                                Joined on
                                            </th>
                                            <th className="min-w-100px">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.sellerData.map((sellerVal: any, index: number) => {
                                            return (
                                                <tr>
                                                    <td className="fs-15 fw-500 text-dark">{sellerVal.ownerName}</td>
                                                    <td className="fs-15 fw-500 text-dark">{sellerVal.name}</td>
                                                    <td className="fs-15 fw-500 text-dark">
                                                        {Method.convertDateToDDMMYYYY(sellerVal._createdAt)}
                                                    </td>
                                                    <td className="py-4 fs-14 fw-600">
                                                        {Method.hasPermission(KycVerifications, View, currentUser) &&
                                                        Method.hasPermission(AllSeller, View, currentUser) ? (
                                                            <Button
                                                                className="uw-btn uw-btn-primary btn btn-primary fs-14 fw-600"
                                                                onClick={() => {
                                                                    handleSellerProfile(sellerVal._id);
                                                                }}
                                                            >
                                                                View details
                                                            </Button>
                                                        ) : (
                                                            <></>
                                                        )}
                                                        {Method.hasPermission(KycVerifications, View, currentUser) &&
                                                        !Method.hasPermission(AllSeller, View, currentUser) ? (
                                                            <Button
                                                                className="uw-btn uw-btn-primary btn btn-primary fs-14 fw-600"
                                                                onClick={() => {
                                                                    setShowPermissionModal(true);
                                                                }}
                                                            >
                                                                View details
                                                            </Button>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                totalRecords={props.total}
                                currentPage={props.currentPage}
                                handleCurrentPage={(event: any) => {
                                    props.handleCurrentPage(event, 2);
                                }}
                                handleNextPage={(event: any) => {
                                    props.handleNextPage(event, 2);
                                }}
                                handlePreviousPage={(event: any) => {
                                    props.handlePreviousPage(event, 2);
                                }}
                                pageLimit={parseInt(props.pageLimit)}
                                handlePageLimit={(event: any) => {
                                    props.handlePageLimit(event, 2);
                                }}
                            />
                        </>
                    ) : (
                        <>
                            <div className="d-flex flex-column flex-center h-100px">
                                <p className="fs-18 fw-500">No records available.</p>
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};
export default NewRequest;
